var exports = {
  "x": "xa15a2ab7--7a7f2c--button",
};

module.exports = exports;
